import type { AlertDto } from "../../types/AlertDto";
import type { AlertEntity } from "../../types/AlertEntity";

export const AlertEntityToDto = ({ ...rest }: Readonly<AlertEntity>): AlertDto => {
    return { ...rest };
};
